import { Chart, ChartOptions } from 'chart.js'
import type { Dayjs } from 'dayjs'
import { externalTooltipHandler } from 'components/charts/chartjs.config'
import { Language } from 'types/language'
import { formatPrice } from 'utils/format'

/**
 * Resolves a CSS custom property from the chart's canvas, so it follows the active theme
 * @param {Chart} chart
 * @param {string} name
 * @returns {string}
 */
const getCssVariable = (chart: Chart, name: string): string => getComputedStyle(chart.canvas).getPropertyValue(name)

export const getPriceHistoryChartOptions = (months: Dayjs[], language: Language, isTablet: boolean): ChartOptions<'line'> => ({
  responsive: true,
  aspectRatio: isTablet ? 3 : 5,
  interaction: {
    mode: 'nearest',
    intersect: false
  },
  elements: {
    line: {
      borderWidth: 2.5,
      borderColor: ({ chart }) => getCssVariable(chart, '--border-high-contrast')
    },
    point: {
      radius: 3,
      hoverRadius: 5,
      borderWidth: 0,
      backgroundColor: ({ chart }) => getCssVariable(chart, '--border-high-contrast')
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      }
    },
    y: {
      title: {
        display: true,
        text: '€/kWh'
      },
      ticks: {
        callback: (value) => formatPrice(Number(value), language, 3)
      }
    }
  },
  plugins: {
    tooltip: {
      enabled: false,
      external: (context) => externalTooltipHandler({ context, totalColumns: months.length, hideTitle: true }),
      callbacks: {
        label: ({ dataIndex, parsed: { y } }) =>
          y === null ? undefined : `${months[dataIndex].format('MMMM YYYY')}: ${formatPrice(y, language, 3)}`
      }
    }
  }
})
